import { render } from "./App.vue?vue&type=template&id=5651e62e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5651e62e&lang=scss"

import exportComponent from "C:\\trabajo_espacio\\cuadros.ges.com\\com.ges.cuadros\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__